import { ISMT_NhomDeThiIn_Request } from "../../../../model/request/de-thi/de-thi-in/ISMT_NhomDeThiIn_Request";
import { ISMT_NhomDeThiIn } from "../../../../model/respone/de-thi/ISMT_NhomDeThiIn";
import { INhomDeThiInActionTypes } from "../../../action-types/de-thi/de-thi-in/INhomDeThiInActions";
import { INhomDeThiInReducer } from "../../../reducer-model/de-thi/de-thi-in/INhomDeThiInReducer";
import { eReducerStatusBase } from "../../../reducer-model/eReducerStatusBase";

const iniState: INhomDeThiInReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  nhomDeThiInEditing: {} as ISMT_NhomDeThiIn,
  nhomDeThiIns: [],
  request: {
    id_he: 0,
    id_mon: 0,
    id_bm: 0,
  } as ISMT_NhomDeThiIn_Request,
};

export const nhomDeThiInReducer = (
  state: INhomDeThiInReducer = iniState,
  action: INhomDeThiInActionTypes
): INhomDeThiInReducer => {
  switch (action.type) {
    case "NHOM_DE_THI_IN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        nhomDeThiIns: [],
      };
    case "NHOM_DE_THI_IN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        nhomDeThiIns: action.payload,
      };
    case "NHOM_DE_THI_IN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_DE_THI_IN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NHOM_DE_THI_IN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "NHOM_DE_THI_IN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_DE_THI_IN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "NHOM_DE_THI_IN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "NHOM_DE_THI_IN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "NHOM_DE_THI_IN_DELETE_MULTIPLE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "NHOM_DE_THI_IN_DELETE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "NHOM_DE_THI_IN_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "NHOM_DE_THI_IN_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "NHOM_DE_THI_IN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        nhomDeThiInEditing: action.payload,
      };
    case "NHOM_DE_THI_IN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        nhomDeThiInEditing: undefined,
      };
    default:
      return state;
  }
};
